/* eslint-disable import/no-anonymous-default-export */
import { LISTAR_RESULTADOS_REA } from "../../types";

export default (state, action) => {
  switch (action.type) {
    case LISTAR_RESULTADOS_REA:
      return {
        ...state,
        resultadosRea: action.payload,
      };

    default:
      return state;
  }
};
